/* KURO — the consent gate on the bag
 *
 * The consent box on the bag is not ours. It is written into the page by the
 * "EZ Terms and Conditions Checkbox" app embed, which also binds a capture
 * listener to the checkout button and answers an unticked box with
 * window.alert(). An alert is a modal the phone draws over the page. It stops
 * the checkout dead, it cannot be styled, and on a phone it takes the whole
 * screen to say one sentence that belongs beside the box it is about. It is
 * the last thing between a full bag and a paid order, and it reads like an
 * error the browser is having rather than a thing the reader has to do.
 *
 * The app's listener sits on the button. A capture listener on the document
 * runs before it — capture descends window → document → … → target — so the
 * click is answered here first and stopPropagation() keeps it from ever
 * reaching the app. That ordering is a property of the event path, not of
 * which script loaded first, which is what makes this safe against an app
 * embed that may load whenever it likes.
 *
 * When the box is ticked nothing is intercepted at all: the app's own check
 * finds it ticked, says nothing, and the form submits the way it always did.
 *
 * Delegated from the document, so nothing here depends on the app having
 * finished writing its markup by the time this runs.
 */
(function () {
  'use strict';

  var CHECKOUT = '[name="checkout"]';
  var BOX = '.rterms-checkbox';
  var ERROR_ID = 'kuro-terms-error';

  /* The app numbers its boxes rterms-0, rterms-1, … one for each checkout
     button it finds on the page. The bag has one button, so there is one
     box, and the first is it. */
  function box() {
    return document.querySelector(BOX);
  }

  /* The sentence is written in the section rather than here, so that it can
     be read in the language the page is being read in. */
  function message() {
    var tag = document.getElementById('kuro-cart-terms');
    return (tag && tag.getAttribute('data-message')) || '';
  }

  function errorNode(button) {
    var node = document.getElementById(ERROR_ID);
    if (node) return node;

    node = document.createElement('p');
    node.id = ERROR_ID;
    node.className = 'kuro-y-terms-error';
    node.setAttribute('role', 'alert');
    node.hidden = true;
    button.parentNode.insertBefore(node, button);
    return node;
  }

  function show(button) {
    var node = errorNode(button);
    node.textContent = message();
    node.hidden = false;

    var input = box();
    if (!input) return;

    input.setAttribute('aria-invalid', 'true');

    /* The header is fixed and 104px tall. A bare focus() scrolls the box to
       the top of the viewport, which is under it, so the box is placed
       first and the focus ring told not to move it again. */
    input.scrollIntoView({ block: 'center' });
    input.focus({ preventScroll: true });
  }

  function hide() {
    var node = document.getElementById(ERROR_ID);
    if (node) node.hidden = true;

    var input = box();
    if (input) input.removeAttribute('aria-invalid');
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest(CHECKOUT);
      if (!button) return;

      var input = box();
      if (!input || input.checked) return;

      event.preventDefault();
      event.stopPropagation();
      show(button);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(BOX) && target.checked) hide();
  });
}());
